import http from '@/http.js'
import eventBus from '@/eventBus.js'
import * as yup from 'yup';
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useForm } from 'vee-validate';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useModifRequete(props, {emit}) {
    const localId = ref(props.idRequetes);
    const idUtilisateur = ref('');
    const schemas = ref([]);
    const schema = ref({});
    const titre = ref('');
    const type = ref('');
    const description = ref('');
    const sql = ref('');
    const gravite = ref('');
    const tables = ref('');
    const message = ref('');
    const keywords = ref('');
    const champAnomalique = ref('');
    const showModal = ref(false);
    const optionType = ref([
        { value: "1", text: "requête" },
        { value: "2", text: "script php" },
    ]);
    const optionGravite = ref([
        { value: "1", text: "Bloquant" },
        { value: "2", text: "Majeur" },
        { value: "3", text: "Mineur" },
    ]);

    const parametres = ref([]);
    const toastMessage = ref("");
    const showNotification = ref(false);
    const toastType = ref("info");
    const duration = ref(5000);

    const invalid = yup.object({
        titre: yup.string().required('Ce champ est obligatoire'),
        description: yup.string().required('Ce champ est obligatoire'),
        sql: yup.string().required('Ce champ est obligatoire'),
    });

    const { handleSubmit } = useForm({
        validationSchema: invalid,
    });

    const handleNotification = (notification) => {
        showNotification.value = notification.showNotification;
        toastMessage.value = notification.toastMessage;
        toastType.value = notification.toastType;
    };

    const emitModifierRequete = handleSubmit(async (values) => {
        try {
            const requeteData = {
                idRequete: localId.value,
                idUtilisateur: idUtilisateur.value,
                titre: values.titre,
                type: type.value,
                description: values.description,
                sql: values.sql,
                gravite: gravite.value,
                tables: tables.value,
                message: message.value,
                keywords: keywords.value,
                champAnomalique: champAnomalique.value,
                schema: schema.value,
                parametres: parametres.value,
            };
            const data = await http.updateRequete(requeteData);
            localId.value = data;
            emit('close');
            eventBus.emit('reloadRequetes');
            emit('notification', {
                showNotification: true,
                toastMessage: "Requête modifiée avec succès!",
                toastType: "success",
            });
        } catch (error) {
            emit('notification', {
                showNotification: true,
                toastMessage: 'Erreur lors de la modification de la requête.',
                toastType: "danger",
            });
        }
    });

    onMounted(() => {
        http.getSchema().then((data) => {
            schemas.value = data;
        });

        if (props.idRequetes !== undefined) {
            http.loadRequete(props.idRequetes).then((data) => {
                titre.value = data.titre;
                description.value = data.description;
                schema.value = data.schema;
                type.value = data.type;
                sql.value = data.sql;
                champAnomalique.value = data.champAnomalique;
                keywords.value = data.keywords;
                gravite.value = data.gravite;
                message.value = data.message;
                tables.value = data.tables;
                parametres.value = data.parametres;
            });
        }
    });

    onBeforeUnmount(() => {
        eventBus.off('modifierRequete', emitModifierRequete);
    });

    return {
        idUtilisateur,
        titre,
        schema,
        type,
        description,
        sql,
        schemas,
        gravite,
        tables,
        message,
        keywords,
        optionType,
        champAnomalique,
        showModal,
        optionGravite,
        parametres,
        emitModifierRequete,
        toastMessage,
        showNotification,
        toastType,
        duration,
        handleNotification,
    };
}
